import React from 'react';
import SearchIcon from 'material-ui/svg-icons/action/search';
import CheckIcon from 'material-ui/svg-icons/action/check-circle';
import { translate } from 'admin-on-rest';

const BRAND_BLUE = '#284263';

const styles = {
    card:    { background: '#fff', borderRadius: 10, boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.03)', overflow: 'hidden' },
    header:  { padding: '12px 16px', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    title:   { fontSize: 13, fontWeight: 700, color: '#111827', letterSpacing: 0.2, display: 'flex', alignItems: 'center', gap: 8 },
    badge:   { fontSize: 11, color: '#6b7280', background: '#f3f4f6', padding: '2px 8px', borderRadius: 999, fontWeight: 600 },
    listWrap:{ maxHeight: 360, overflowY: 'auto' },
    row:     { display: 'flex', alignItems: 'center', gap: 8, padding: '8px 16px', borderBottom: '1px solid #f9fafb', fontSize: 12 },
    date:    { fontSize: 11, color: '#9ca3af', minWidth: 70 },
    link:    { color: BRAND_BLUE, textDecoration: 'none', fontWeight: 500 },
    linkSub: { color: '#374151', textDecoration: 'none' },
    sep:     { color: '#d1d5db', margin: '0 4px' },
    iconBtn: { width: 16, height: 16, color: '#9ca3af', marginLeft: 'auto', cursor: 'pointer' },
    empty:   { padding: 24, textAlign: 'center', color: '#9ca3af', fontSize: 12 },
};

export default translate(({ ads = [], nb }) => (
    <div style={styles.card}>
        <div style={styles.header}>
            <span style={styles.title}>
                <CheckIcon style={{ width: 14, height: 14, color: BRAND_BLUE }} />
                {nb}
            </span>
            <span style={styles.badge}>{ads.length}</span>
        </div>
        <div style={styles.listWrap}>
            {ads.length === 0 && <div style={styles.empty}>Niets te tonen</div>}
            {ads.map((record) => (
                <div key={record.id} style={styles.row}>
                    <span style={styles.date}>{new Date(record.created_at).toLocaleDateString('nl-NL')}</span>
                    <a style={styles.link} href={`#/admin/customers/${record.user.id}`}>{record.user.company_name}</a>
                    <span style={styles.sep}>·</span>
                    <a style={styles.linkSub} href={`#/admin/cloudhintsdomains/${record.cloudhintsdomains.id}`}>{record.cloudhintsdomains.title}</a>
                    <a href={`#/admin/ad/${record.id}`} style={styles.iconBtn}><SearchIcon style={{ width: 16, height: 16, color: '#9ca3af' }} /></a>
                </div>
            ))}
        </div>
    </div>
));



// WEBPACK FOOTER //
// ./src/dashboard/PendingAdsList.js